import { BaseCoverImageUploadViewStore } from "common/stores";

// Reuses the shared cover-image upload machinery (file picker + upload + preview) but targets the
// naki-nigun-import artwork endpoint and reports the resulting MediaVault file-entry id back to the
// batch edit store through `onChange` so it can be included in the metadata save payload.
class NakiNigunImportArtworkUploadViewStore extends BaseCoverImageUploadViewStore {
    constructor(rootStore, { routeStore, existingFileEntryId, onChange, width = 200, height = 200 } = {}) {
        super(rootStore, { width, height });
        this.routeStore = routeStore;
        this.onChange = onChange;

        if (existingFileEntryId) {
            this.setUploadedFileId(existingFileEntryId);
            // Derive the preview URL immediately. The base store only sets imageUrl via a reaction on
            // uploadedFileId, but that reaction isn't active yet during construction, so an existing cover
            // would show no image (and therefore no "Remove" button) until the id changed again. Set it
            // explicitly here, the same way the artist-edit cover uploader does on load.
            this.setImageUrl(this.getMediaVaultFileUrl(existingFileEntryId));
        }

        this.reaction(
            () => this.uploadedFileId,
            (id) => {
                if (this.onChange) {
                    this.onChange(id);
                }
            }
        );
    }

    async uploadImageToMediaVault(file) {
        const result = await this.routeStore.uploadArtwork(file);
        // The import artwork endpoint returns `{ fileEntryId }`; the base store expects `.id`.
        return { id: result.fileEntryId };
    }

    getMediaVaultFileUrl(id) {
        return this.routeStore.getMediaVaultFileUrl(id);
    }
}

export default NakiNigunImportArtworkUploadViewStore;
